import { render, staticRenderFns } from "./Abholzeiten.vue?vue&type=template&id=648e5f0e&scoped=true"
import script from "./Abholzeiten.vue?vue&type=script&lang=js"
export * from "./Abholzeiten.vue?vue&type=script&lang=js"
import style0 from "./Abholzeiten.vue?vue&type=style&index=0&id=648e5f0e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648e5f0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('648e5f0e')) {
      api.createRecord('648e5f0e', component.options)
    } else {
      api.reload('648e5f0e', component.options)
    }
    module.hot.accept("./Abholzeiten.vue?vue&type=template&id=648e5f0e&scoped=true", function () {
      api.rerender('648e5f0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Abholzeiten.vue"
export default component.exports